import { AlertTriangle, FileSearch } from "lucide-react";

import type { LeaveDocument, LeaveDocumentAnalysis } from "../types/leaveDocument";
import {
  balanceRowCount,
  hasNothingToCompare,
  leaveEntryCount,
  periodLabel,
} from "../types/leaveDocument";

type Props = {
  document: LeaveDocument;
  analysis: LeaveDocumentAnalysis | null;
  // De detailpagina toont de waarschuwingen al bij de te bevestigen
  // AI-bevindingen; daar hoeven ze niet nog een keer in de samenvatting.
  showWarnings?: boolean;
};

// Wat de analyse heeft herkend en wat er niet gelezen kon worden. Zonder dit
// blok is een analyse zonder regels onzichtbaar: geen fout, geen verschillen,
// alleen een status.
export default function LeaveDocumentAnalysisSummary({
  document,
  analysis,
  showWarnings = true,
}: Props) {
  if (!analysis || document.status === "failed") return null;
  const warnings = showWarnings ? analysis.warnings ?? [] : [];

  return (
    <div className="document-analysis-summary">
      <p className="field-hint">
        Herkend: {leaveEntryCount(analysis)} verlofregel(s) en{" "}
        {balanceRowCount(analysis)} saldoregel(s) · {periodLabel(document)}
        {document.employer_name ? ` · ${document.employer_name}` : ""} ·{" "}
        {analysis.differences.length} regel(s) vergeleken
      </p>
      {warnings.length > 0 && (
        <div className="notice notice-warning" role="note">
          <AlertTriangle size={18} />
          <span>
            <strong>Aandachtspunten uit de analyse</strong>
            <ul>
              {warnings.map((warning) => (
                <li key={warning}>{warning}</li>
              ))}
            </ul>
          </span>
        </div>
      )}
      {hasNothingToCompare(analysis) && (
        <div className="empty-state compact">
          <FileSearch size={25} />
          <h2>Niets herkend om te vergelijken</h2>
          <p>
            In dit document zijn geen verlofregels of saldo&apos;s gevonden. Controleer
            of het een week- of maandstaat is en analyseer het eventueel opnieuw.
          </p>
        </div>
      )}
    </div>
  );
}
